'use client';

import styled from "styled-components";

export const Container = styled.div`
  width: 50vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  
  align-items: center;     
  justify-content: flex-start; 

  gap: 10px;                 
`;
